import { TriangleAlertIcon } from 'lucide-react'

export const Warnings = ({ warnings }: { warnings: string[] }) =>
  warnings.length > 0 ? (
    <ul
      data-edit-warnings
      className="space-y-2 rounded-lg bg-amber-50 px-3 py-2.5 text-sm text-amber-950 ring-1 ring-amber-200"
    >
      {warnings.map((warning) => (
        <li key={warning} className="flex gap-2">
          <TriangleAlertIcon className="mt-0.5 size-4 shrink-0 text-amber-600" />
          {warning}
        </li>
      ))}
    </ul>
  ) : null
